import { useEffect } from 'react';
import { useReportes } from '../../../hooks/reportes/useReportes';
import { TabsReportes } from '../../components/tabs/TabsReportes';

export const Reportes = () => {
    const {
        listarReportes,
        reportes,
    } = useReportes()


    // useEffect(() => {
    //     (async () => {
    //         await listarReportes()
    //     })()
    // },[])
    
    return(
        <div
            className="px-3 py-5 relative top-0 bottom-0 left-0 right-0 contenedor-tabla w-full h-full overflow-hidden"
        >
            <TabsReportes listaMenus={reportes}></TabsReportes>
        </div>
   ) 
}